import { createSlice } from '@reduxjs/toolkit';

// Initial state for sensor-related data
const initialState = {
  sensors: [], // List of sensors fetched from API
  loading: false, // Loading state for API calls
  error: null, // Error state for any issues
};

// Create the sensor slice with actions for setting data
const sensorSlice = createSlice({
  name: 'sensor',
  initialState,
  reducers: {
    fetchSensorsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSensorsSuccess: (state, action) => {
      state.sensors = action.payload;
      state.loading = false;
    },
    fetchSensorsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createSensorSuccess: (state, action) => {
      state.sensors.push(action.payload);
      state.loading = false;
    },
    createSensorFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Actions for updating water level sensor
    updateWaterLevelSensorStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateWaterLevelSensorSuccess: (state, action) => {
      const updatedSensor = action.payload;
      const index = state.sensors.findIndex(sensor => sensor._id === updatedSensor._id);
      if (index !== -1) {
        state.sensors[index] = updatedSensor;
      }
      state.loading = false;
    },
    updateWaterLevelSensorFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Actions for updating alarm settings
    updateAlarmSettingsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateAlarmSettingsSuccess: (state, action) => {
      const updatedSensor = action.payload;
      const index = state.sensors.findIndex(sensor => sensor._id === updatedSensor._id);
      if (index !== -1) {
        state.sensors[index] = updatedSensor;
      }
      state.loading = false;
    },
    updateAlarmSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions for dispatch
export const {
  fetchSensorsStart,
  fetchSensorsSuccess,
  fetchSensorsFailure,
  createSensorSuccess,
  createSensorFailure,
  updateWaterLevelSensorStart,
  updateWaterLevelSensorSuccess,
  updateWaterLevelSensorFailure,
  updateAlarmSettingsStart,
  updateAlarmSettingsSuccess,
  updateAlarmSettingsFailure,
} = sensorSlice.actions;

export default sensorSlice.reducer;
